<template>
<div>

    <el-dialog title="Enrolamiento de usuario" :visible.sync="visible">
        <el-form :model="form">
            <el-form-item label="Dispositivo">
                <el-select v-model="form.device_id" filterable placeholder="Seleccione">
                    <el-option
                        v-for="item in DevicesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>                
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleEnrollmentCancel">Cancelar</el-button>
            <el-button v-if="action == 'setUser'" type="primary" @click="handleRegisterUser">Enviar a dispositivo enrolador</el-button>
            <el-button v-if="action == 'getUserTemplate'" type="primary" @click="handleSyncTemplate">Tomar rostro de dispositivo</el-button>
        </span>
    </el-dialog>

</div>
</template>

<script>
    export default {
        name: 'employee-enrollment',
        props:{
            visible: Boolean,
            action: String,
            employee: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                DevicesOptions: [],
                form: {
                    device_id: null,

                }
            }
        },
        mounted() {
            axios.get('/api/devices/optionswithdefault').then((response) => {
                _.each(response.data, (option) => {
                    this.DevicesOptions.push({label: option.name, value: option.id});
                    if (option.is_default_for_enrollment) {
                        this.form.device_id = option.id;
                    }
                });
            });
        },
        methods: {
            handleEnrollmentCancel () {
                // this.dialogFormVisible = false;
                // this.$refs['crud'].$refs['dataTable'].data[this.selectedEmployeeIdx].has_face_template;
                this.$emit('done');
            },
            handleRegisterUser () {
                axios.put('/api/employees/'+this.employee.id+'/sendtoregistrationdevice', this.form).then((response) => {
                    // console.log(response);
                    this.$emit('done');
                });
            },
            // handleUnenrollUser () {
            //     axios.post('/api/employees/'+this.employee.id+'/removefromdevices').then((response) => {
            //         console.log(response);
            //     });
            // },
            handleSyncTemplate () {
                axios.put('/api/employees/'+this.employee.id+'/getfacetemplate', this.form).then((response) => {
                    // console.log(response);
                    this.$emit('done');
                });
                // this.statusStep2 = 'success';
            }
        }
    }
</script>